import script from "./SignUpView.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpView.vue?vue&type=script&setup=true&lang=js"

import "./SignUpView.vue?vue&type=style&index=0&id=cb3e51e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb3e51e0"]])

export default __exports__